import { useCallback, useEffect, useState } from 'react';
import type { StaffMember } from '../api/types.ts';
import { useShop } from '../app/boot.tsx';
import { useShopPaths } from '../app/nav.tsx';
import { message } from '../lib/errors.ts';
import { Button, Card, Chip, Dialog, Loading, Page, useToast } from '../ui/index.tsx';

export function StaffList() {
  const { api, me } = useShop();
  const { go } = useShopPaths();
  const toast = useToast();
  const [rows, setRows] = useState<StaffMember[] | null>(null);
  const [removing, setRemoving] = useState<StaffMember | null>(null);
  const [busy, setBusy] = useState(false);

  const load = useCallback(() => api.staff.staffList().then(setRows).catch((e) => { toast(message(e), 'error'); setRows([]); }), [api, toast]);
  useEffect(() => { void load(); }, [load]);

  async function remove() {
    if (!removing) return;
    setBusy(true);
    try {
      await api.staff.removeStaff(removing.lineUserId);
      toast('นำออกแล้ว', 'success');
      setRemoving(null);
      void load();
    } catch (e) {
      toast(message(e), 'error');
      setRemoving(null);
    } finally {
      setBusy(false);
    }
  }

  return (
    <Page title="พนักงาน" back={() => go('/staff/manage')}>
      <p className="muted small" style={{ marginBottom: 12 }}>เชิญช่างได้จากหน้า “ช่าง” → เลือกช่าง → สร้างลิงก์เชิญ</p>
      {rows === null ? <Loading /> : (
        <div className="list">
          {rows.map((s) => (
            <Card key={s.lineUserId} className="row-between">
              <div>
                <div className="card-title">{s.displayName ?? s.barberName ?? 'พนักงาน'}{s.lineUserId === me.staff?.lineUserId ? ' (คุณ)' : ''}</div>
                <div className="row" style={{ marginTop: 4 }}>
                  <Chip tone={s.role === 'owner' ? 'dark' : 'default'}>{s.role === 'owner' ? 'เจ้าของร้าน' : 'ช่าง'}</Chip>
                  {s.barberName && <span className="muted small">โปรไฟล์ช่าง: {s.barberName}</span>}
                </div>
              </div>
              <Button variant="ghost" className="btn-sm" onClick={() => setRemoving(s)}>นำออก</Button>
            </Card>
          ))}
        </div>
      )}
      <Dialog open={removing !== null} title="นำพนักงานออก?" confirmLabel="นำออก" danger loading={busy} onConfirm={() => void remove()} onCancel={() => setRemoving(null)}>
        <p>บัญชี LINE นี้จะไม่เห็นหน้าพนักงานอีก (การจองที่มีอยู่ไม่ได้รับผลกระทบ)</p>
      </Dialog>
    </Page>
  );
}
